import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Email = createSvgIcon(
  <path d="M24 3H0v18h24V3ZM2.25 6.466l9.75 9.75 9.75-9.75V18.75H2.25V6.466ZM19.784 5.25 12 13.034 4.216 5.25h15.568Z" />,
  'Email'
);

export { Email };